import Joi from 'joi';
import api from '../../api';
import { mediaSchema, paginationSchema } from '../schemas';

/**
 * Get a media by its ID.
 * @param {string} mediaId
 * @returns {Promise<Media>}
 */
export const getMedia = async (mediaId) => {
  const result = await api.get(`/content-management/v1-0/admin/medias/${mediaId}`);

  try {
    await mediaSchema.validateAsync(result.data, { allowUnknown: true });
  } catch (error) {
    throw new Error(`API response do not match Media Schema : ${error.message}`);
  }

  return result.data;
};
/**
 * Get all media
 * @param {object} queryParams
 * @param {number} queryParams.pageNumber
 * @param {number} queryParams.pageSize
 * @param {string|null} [queryParams.folderId]
 * @param {string|null} [queryParams.search]
 * @param {string|null} [queryParams.sort]
 * @returns {Promise<{data: Media[], pagination: Pagination}>}
 */
export const getAllMedia = async (queryParams) => {
  const result = await api.get('/content-management/v1-0/admin/medias', { params: queryParams });

  try {
    const schema = Joi.object({
      data: Joi.array().items(mediaSchema).required(),
      pagination: paginationSchema,
    });
    await schema.validateAsync(result.data, { allowUnknown: true });
  } catch (error) {
    throw new Error(`API response do not match All Media Schema : ${error.message}`);
  }

  return result.data;
};
/**
 * Update a Media
 * @param {string} mediaId
 * @param {object} updatedMedia
 * @param {string} updatedMedia.name
 * @param {Array<{localeId: string, content: string}>} updatedMedia.description
 * @param {string} updatedMedia.credit
 * @param {number} version
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const updateMedia = async (mediaId, updatedMedia, version) => api.patch(
  `/content-management/v1-0/admin/medias/${mediaId}`,
  updatedMedia,
  {
    headers: {
      'X-Presumed-Version': version,
    },
  },
);
/**
 * Create a new Media
 * @param {object} newMedia
 * @param {string} newMedia.name
 * @param {string} newMedia.folderId
 * @param {string} newMedia.url
 * @param {Array<{localeId: string, content: string}>} newMedia.description
 * @param {string} newMedia.credit
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const postMedia = async (newMedia) => api.post('/content-management/v1-0/admin/medias', newMedia, {
  headers: {
    'Content-Type': 'application/json',
  },
});
/**
 * Archive a Media
 * @param {string} mediaId
 * @param {number} version
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const postArchiveMedia = async (mediaId, version) => api.post(
  `/content-management/v1-0/admin/medias/${mediaId}:archive`,
  undefined,
  {
    headers: {
      'X-Presumed-Version': version,
    },
  },
);
